export enum EventAction {
  HeaderClick = 'clique:header',
  ErrorPage = 'erro:pagina',
  ErrorModal = 'erro:modal',
  ErrorLeadForm = 'erro:fale-corretor',
  UserRegisterSuccessCallback = 'callback:cadastro',
  UserRegisterRequestSuccessCallback = 'callback:requisicao-cadastro',
  ContactUsSuccessCallback = 'callback:fale-conosco',
  CalculatorSuccessCallback = 'callback:calculadora',
  Clique = 'clique',
  Click = 'click',
  ButtonClick = 'clique:botao',
  FilterClick = 'clique:filtro',
  PostClick = 'clique:posts',
  CardClick = 'clique:card',
  AddToCart = 'addToCart',
  Checkout = 'checkout',
  Purchase = 'purchase',
  SearchFilterInteraction = 'interacao-filtros',
  HomeSearchFilterDealTypeInteraction = 'clique:tipo-busca',
  Login = 'callback:login',
  FooterClick = 'clique:footer',
  FranchiseProspectSuccessCallback = 'callback:franqueado',
  AdvertiseSuccessCallback = 'callback:anuncio',
  CardCarousel = 'interacao-carrossel-imagens'
}
